import { config } from '../config';
import type { InfoSection } from './InfoDialog';
import { LogoMark } from './Logo';

const LINKS: Array<[InfoSection, string, 'always' | 'wide']> = [
  ['about', 'About', 'always'],
  ['how', 'How it works', 'wide'],
  ['content', 'Content policy', 'wide'],
  ['privacy', 'Privacy', 'always'],
  ['terms', 'Terms', 'always'],
  ['contact', 'Report a post', 'always'],
];

/** One slim line, signed with the logo: the board gets the space. */
export function Footer({ onInfo }: { onInfo: (section: InfoSection) => void }) {
  return (
    <footer className="footer">
      <span className="footer__brand">
        <LogoMark className="footer__mark" />
        <span className="footer__name">
          <b>talk</b> of the <b className="brand__town">town</b>
        </span>
        <span className="footer__copy">© {new Date().getFullYear()}</span>
      </span>
      <nav className="footer__links" aria-label="About and policies">
        {LINKS.map(([section, label, show]) => (
          <button
            key={section}
            type="button"
            className={`footer__link${show === 'wide' ? ' footer__link--wide' : ''}`}
            onClick={() => onInfo(section)}
          >
            {label}
          </button>
        ))}
        {config.contactEmail && (
          <a className="footer__link" href={`mailto:${config.contactEmail}`}>
            Contact
          </a>
        )}
      </nav>
    </footer>
  );
}
